import { format, unwrapFunctionStore } from 'svelte-i18n';

import { typeCharacters } from '@client/utils/dom';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const campaignModal = {
  element: '.modal-content',
  popover: {
    title: 'Campaign Details',
    description:
      "Add the basics—campaign name, scheduling, tags, categories, and folders. When you're ready, click <strong>&quot;Next <i class='os-icon-arrow-right'></i> Setup&quot;</strong> to design your ad.",
    side: 'right',
    align: 'center',
    onPrevClick: () => {
      const closeBtn = document.querySelector('.close');

      if (closeBtn) {
        closeBtn.click();

        GLOBAL_DRIVER_OBJECT.movePrevious();
      }
    }
  }
};

export const campaignModalName = {
  element: 'div.modal-body > div > div > div:nth-child(1)',
  popover: {
    title: 'Campaign Name',
    description: 'Pick a unique, clear, and descriptive name to easily spot and reference your campaign later.',
    side: 'right',
    align: 'center',
    onPopoverRender: () => {
      const nameInput = document.querySelector(' div.campaign-actions.name > input');

      if (nameInput && nameInput.value === '') {
        typeCharacters(nameInput, 'tour_campaign_name', 75);
      }
    }
  }
};

export const campaignModalSchedule = {
  element: 'div.modal-body > div > div > div:nth-child(2)',
  popover: {
    title: 'Schedule',
    description:
      'Optional but handy! Set start and end dates for your campaign, or leave it unscheduled to keep it running until you turn it off.',
    side: 'right',
    align: 'center',
    onNextClick: () => {
      const scheduleSwitch = document.querySelector(
        'div.modal-body > div > div > div:nth-child(2) > div.campaign-actions > label > input'
      );

      if (scheduleSwitch && !scheduleSwitch.checked) {
        scheduleSwitch.click();
      }

      setTimeout(() => {
        GLOBAL_DRIVER_OBJECT.moveNext();
      }, 400);
    },
    onPrevClick: () => {
      const scheduleSwitch = document.querySelector(
        'div.modal-body > div > div > div:nth-child(2) > div.campaign-actions > label > input'
      );

      if (scheduleSwitch && scheduleSwitch.checked) {
        scheduleSwitch.click();
      }

      setTimeout(() => {
        GLOBAL_DRIVER_OBJECT.movePrevious();
      }, 100);
    }
  }
};

export const campaignModalScheduleDates = {
  element: 'div.modal-body > div > div > div:nth-child(3)',
  popover: {
    title: 'Schedule Dates',
    description: 'Set start and end dates to automate your campaign’s visibility—perfect for planning ahead!',
    side: 'right',
    align: 'center'
  }
};

export const campaignModalTags = {
  element: 'div.modal-body > div > div > div:nth-child(4)',
  popover: {
    title: 'Tags',
    description:
      "Tags let you group, target, or classify your ad banner campaigns. They're optional—create new ones or pick from existing tags if you need them!",
    side: 'right',
    align: 'center'
  }
};

export const campaignModalCategories = {
  element: 'div.modal-body > div > div > div:nth-child(5)',
  popover: {
    title: 'Categories',
    description:
      'Pre-set categories help keep your campaigns organized. Use them to stay structured—totally optional but worth it!',
    side: 'right',
    align: 'center',
    onNextClick: () => {
      const folderSection = document.querySelector('#folder-section-campaigns-modal');

      if (folderSection) {
        GLOBAL_DRIVER_OBJECT.moveNext();
      } else {
        GLOBAL_DRIVER_OBJECT.moveTo(9);
      }
    }
  }
};

export const campaignModalFolders = {
  element: 'div.modal-body > div > div > div:nth-child(6)',
  popover: {
    title: 'Folders',
    description:
      'Folders help you organize your banner campaigns. They also allow you to find or filter campaigns based on the assigned folder easily.',
    side: 'right',
    align: 'center'
  }
};

export const goToAdModal = {
  element: '#modal-next-btn',
  popover: {
    title: 'Design Your Ad',
    description:
      "When you're ready, click <strong>&quot;Next <i class='os-icon-arrow-right'></i> Setup&quot;</strong> to design your ad.",
    side: 'top',
    align: 'center',
    onPrevClick: () => {
      const folderSection = document.querySelector('#folder-section-campaigns-modal');

      if (folderSection) {
        GLOBAL_DRIVER_OBJECT.movePrevious();
      } else {
        GLOBAL_DRIVER_OBJECT.moveTo(7);
      }
    },
    onNextClick: () => {
      const nextButton = document.querySelector('#modal-next-btn');

      if (nextButton) {
        nextButton.click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.moveNext();
        }, 200);
      }
    }
  }
};
